var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right-chart-1"},[_c('div',{staticClass:"rc1-header"},[_vm._v("家长接送总人数")]),_c('div',{staticClass:"rc1-chart-container"},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"number"},[_vm._v(_vm._s(_vm.allActive))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }